const ValidationRules = {
    required: [
        v => !!v && v != '' || 'Required',
        //v => (v) ? v : false,
    ],
    nameRules: [
        v => (v && v.length <= 50) || 'Name must be less than 50 characters',
    ],
    emailRules: [
        v => (v && v != "") ? /.+@.+\..+/.test(v) || 'E-mail must be valid' : true,
    ],
    emailWithoutExtension: [
        v => (v && v != "") ? /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+$/.test(v) || 'Enter email without extension' : true,
    ],
    number: (min, max) => [
        v => v != "" ? /^[0-9]+$/.test(v) || 'Invalid number' : true,
        v => v != "" ? (v && v >= min) || 'Min allowed value ' + min : true,
        v => v != "" ? (v && v <= max) || 'Max allowed value' + max : true,

    ],
    passwordConfirm: (pass) => [
        v => v == pass || 'Password not match'
    ],
    domain: [
        v => (v && v != "") ? /^[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}$/.test(v) || 'Invalid domain' : true,
    ],
    url: [
        v => (v && v != "") ? /^(http|https):\/\/[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(([0-9]{1,5})?\/.*)?/.test(v) || 'Invalid URL' : true,
    ],
    alphanumeric: [
        v => (v && v != "") ? /^[a-zA-Z0-9_]*$/.test(v) || 'Allowed only alphanumeric' + v : true,
    ],
    mobileno: [
        v => (v && v != "") ? /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(v) || 'Invalid mobile number' : true,
    ],
    customregexpression: (exp) => [
        v => (v && v != "") ? (new RegExp(exp)).test(v) || 'Invalid value' : true,
    ],

}

export default ValidationRules;
